export default (editor, opts) => {
  const dc = editor.DomComponents;
  const { type, label, labels, types, projectId, multiTenantPlugin } = opts;
  const {
    setting: { subTenantField },
  } = multiTenantPlugin ? multiTenantPlugin : '';
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          'custom-name': label,
          projectId: projectId,
          subTenantField: subTenantField,
          tagName: 'li',
          classes: ['nav-item', 'dropdown'],
          droppable: false, // Can't drop other elements inside
          traits: [
            { type: 'webconnect-event', label: 'Event', name: 'data-sub-tenant-action' },
            {
              type: 'text',
              label: 'Deselect Option Text (Optional)',
              name: 'data-custom-none-option',
              placeholder: '(Default: None)',
              info: 'This text will be displayed as the first option in the dropdown to deselect any selected sub-tenant. If left blank, the default text "None" will be used.',
            },
          ].concat(defaultModel.prototype.defaults.traits),
          script: function () {
            if (typeof loadSubTenantDropdown !== 'undefined') {
              console.log('*** Loading Sub Tenant Dropdown...');
              let subTenantField = '{[ subTenantField ]}';
              loadSubTenantDropdown(this, subTenantField);
            }
          },
        },
        init() {},
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView,
  });
  dc.addType(types.nav_item_dropdown_menu, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          'custom-name': labels.labelNavItemDropdownMenu,
          tagName: 'ul',
          classes: ['dropdown-menu'],
          droppable: false, // Can't drop other elements inside
          removable: false,
          draggable: false,
          highlightable: false,
          copyable: false,
          resizable: false,
          editable: false,
          layerable: false,
          selectable: false,
          hoverable: false,
        },
        init() {},
      },
      {
        isComponent(el) {
          if (
            el.getAttribute &&
            el.getAttribute('data-gjs-type') === types.nav_item_dropdown_menu
          ) {
            return {
              type: types.nav_item_dropdown_menu,
            };
          }
        },
      },
    ),
    view: defaultView,
  });
};
